/**
 * String utilities
 */
/**
 * package: com.inq.utils
 * class: StringUtil
 * @extends StringTools
 * @constructor
 */
com.inq.utils.StringUtil = function () {
};
$hxClasses['com.inq.utils.StringUtil'] = com.inq.utils.StringUtil;
/** @private @type {Array} */
com.inq.utils.StringUtil.__name__ = ["com", "inq", "utils", "StringUtil"];
/** @private @type {Function} */
com.inq.utils.StringUtil.__super__ = StringTools;
for (var k in StringTools.prototype) com.inq.utils.StringUtil.prototype[k] = StringTools.prototype[k];

/**
 * trim
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public static function trim(s:String):String
 * @public
 * @static
 * @param {string} s
 * @return {string}
 */
com.inq.utils.StringUtil.trim = function (s) {
	return StringTools.trim(s);
};


/**
 * htmlDecode
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public static function htmlDecode (s:String):String
 * @public
 * @static
 * @param {string} s
 * @return {string}
 */
com.inq.utils.StringUtil.htmlDecode = function (s) {
	/** @type {string} */
	var res = StringTools.htmlUnescape(s);
	return res;
};


/**
 * Encodes a string for usage inside HTML attributes.
 * @public
 * @static
 * @param {string} s
 * @returns {string}
 */
com.inq.utils.StringUtil.htmlAttrEscape = function (s) {
	return s.split("'").join("&#39;").split('"').join("&quot;");
};


/**
 * escapeForJs
 *
 * $type TFun([{ name => val, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * private static function escapeForJs(val:String):String
 * @private
 * @static
 * @param {string} val
 * @return {string}
 */
com.inq.utils.StringUtil.escapeForJs = function (val) {
	/** @type {string} */
	var value = val;
	value = com.inq.utils.StringUtil.escapeSpecialCharacters(value);
	value = value.split("\"").join("\\\"");
	value = value.split("'").join("\\'");
	return value;
};

/**
 * Escaping special characters: "\", "\n", "\r", "\t".
 */
com.inq.utils.StringUtil.escapeSpecialCharacters = function (val) {
	/** @type {string} */
	var value = val;
	value = value.split("\\").join("\\\\");
	value = value.split("\n").join("\\n");
	value = value.split("\r").join("\\r");
	value = value.split("\t").join("\\t");
	return value;
};


/**
 * toJsString
 *
 * $type TFun([{ name => value, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public static function toJsString(value:String):String
 * @public
 * @static
 * @param {string} value
 * @return {string}
 */
com.inq.utils.StringUtil.toJsString = function (value) {
	return "'" + com.inq.utils.StringUtil.escapeForJs(value) + "'";
};


/**
 * toJsonString
 *
 * $type TFun([{ name => value, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public static function toJsonString(value:String):String
 * @public
 * @static
 * @param {string} value
 * @return {string}
 */
com.inq.utils.StringUtil.toJsonString = function (value) {
	return "\"" + com.inq.utils.StringUtil.escapeForJs(value) + "\"";
};


/**
 * urlDecode
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public static function urlDecode(s:String):String
 * @public
 * @static
 * @param {string} s
 * @return {string}
 */
com.inq.utils.StringUtil.urlDecode = function (s) {
	return StringTools.urlDecode(s);
};

/**
 * isEmptyString - is used to check passed param by type and its length ignoring left and right spaces.
 *
 * @param {*} str
 * @return {boolean}
 */
com.inq.utils.StringUtil.isEmptyString = function (str) {
	return typeof (str) !== 'string' || str.trim().length === 0;
};

/** @type {com.inq.utils.StringUtil} */
com.inq.utils.StringUtil.prototype.__class__ = com.inq.utils.StringUtil;
